let move_devices_devicegroup_info_template =`{{#if region}}
<div>
  <b>Device Group Region</b>
</div>
<div style="overflow: hidden;text-overflow: ellipsis;">
  <div class="region">{{region}}</div>
</div>
{{/if}}
{{#if deployment}}
<div><b>Latest deployment</b></div>
<div style="overflow: hidden;text-overflow: ellipsis;">
<div class="sha" style="overflow:hidden">{{short_sha deployment.sha}}</div>
<div class="created_at">{{#date_UTC}}{{deployment.created_at}}{{/date_UTC}}</div>
</div>
{{else}}
    {{#if product}}
        {{#if is_production_devicegroup}}
<div><b>Latest deployment</b></div>
<div class="warning-block">
  <span>
    <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
    No deployments. Cannot move devices to selected device group.
  </span>
</div>
        {{else}}
<div>
  <em>No deployments for this device group</em>
</div>
        {{/if}}
    {{/if}}
{{/if}}
{{#unless product}}
<div>
  <em>No device group selected</em>
</div>
{{/unless}}`;

export default move_devices_devicegroup_info_template;
